import { render, staticRenderFns } from "./AddEditProduct.vue?vue&type=template&id=1be81320&scoped=true&"
import script from "./AddEditProduct.vue?vue&type=script&lang=js&"
export * from "./AddEditProduct.vue?vue&type=script&lang=js&"
import style0 from "./AddEditProduct.vue?vue&type=style&index=0&id=1be81320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be81320",
  null
  
)

export default component.exports